var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-slug-container flex-centerize mr-3"},[(_vm.serviceSlug)?_c('SIcon',{attrs:{"name":_vm.serviceSlug,"width":20}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }